// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._b-0 {\n  display: flex;\n}\n\n._b-1 {\n  flex-direction: row;\n}\n\n._b-2 {\n  flex-direction: column;\n}\n\n._b-3 {\n  flex-direction: row-reverse;\n}\n\n._b-4 {\n  flex-direction: column-reverse;\n}\n\n._b-5 {\n  align-items: center;\n}\n._b-6 {\n  align-items: flex-start;\n}\n._b-7 {\n  align-items: flex-end;\n}\n._b-8 {\n  align-items: stretch;\n}\n._b-9 {\n  align-items: baseline;\n}\n\n._b-a {\n  align-self: center;\n}\n._b-b {\n  align-self: flex-start;\n}\n._b-c {\n  align-self: flex-end;\n}\n._b-d {\n  align-self: stretch;\n}\n._b-e {\n  align-self: baseline;\n}\n\n._b-f {\n  justify-content: center;\n}\n._b-g {\n  justify-content: flex-start;\n}\n._b-h {\n  justify-content: flex-end;\n}\n._b-i {\n  justify-content: space-between;\n}\n._b-j {\n  justify-content: space-around;\n}\n._b-k {\n  justify-content: space-evenly;\n}\n\n._b-l {\n  flex-wrap: wrap;\n}\n\n._b-m {\n  flex-wrap: nowrap;\n}\n\n._b-n {\n  flex-wrap: wrap-reverse;\n}\n", ""]);
// Exports
export var flex = "_b-0";
export var row = "_b-1";
export var column = "_b-2";
export var rowReverse = "_b-3";
export var columnReverse = "_b-4";
export var alignCenter = "_b-5";
export var alignFlexStart = "_b-6";
export var alignFlexEnd = "_b-7";
export var alignStretch = "_b-8";
export var alignBaseline = "_b-9";
export var alignSelfCenter = "_b-a";
export var alignSelfFlexStart = "_b-b";
export var alignSelfFlexEnd = "_b-c";
export var alignSelfStretch = "_b-d";
export var alignSelfBaseline = "_b-e";
export var justifyCenter = "_b-f";
export var justifyFlexStart = "_b-g";
export var justifyFlexEnd = "_b-h";
export var justifySpaceBetween = "_b-i";
export var justifySpaceAround = "_b-j";
export var justifySpaceEvenly = "_b-k";
export var wrapWrap = "_b-l";
export var wrapNowrap = "_b-m";
export var wrapWrapReverse = "_b-n";
export default ___CSS_LOADER_EXPORT___;
